import { mapActions, mapGetters } from 'vuex'
import { eventBus } from '@/main'

export default {
    computed: {
        ...mapGetters({
            appSettingsReceived: 'appApi/AppSettings',
        }),
        ParsedAppToken() {
            let base64Url = sessionStorage.appToken.split('.')[1];
            let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            let jsonPayload = decodeURIComponent(window.atob(base64).split('').map(c => {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));

            return JSON.parse(jsonPayload);
        },
        KeycloakID() { return this.ParsedAppToken['KeycloakID']; },
        Username() { return this.ParsedAppToken['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name']; },
        DisplayName() { return this.ParsedAppToken['DisplayName']; },
        Initials() {
            if (this.DisplayName != null) {
                let firstName = this.DisplayName?.split(' ')[0];
                let surname = this.DisplayName?.split(' ')[1];

                return firstName.charAt(0).toUpperCase() + surname.charAt(0).toUpperCase();
            }
            return null;
        },
    },
    methods: {
        ...mapActions({
            FetchApiAuthToken: 'appApi/FetchAuthToken',
            FetchAppSettings: 'appApi/FetchAppSettings',
        }),
        LoadAppAuthToken(keycloakID, username, displayName) {
            eventBus.$emit('app-api-auth-token-fetch:started');
            this.FetchApiAuthToken({ KeycloakID: keycloakID, Username: username, DisplayName: displayName })
                .then(authToken => eventBus.$emit('app-api-auth-token-fetch:success', authToken))
                .catch(error => eventBus.$emit('console:error', error))
                .finally(() => eventBus.$emit('app-api-auth-token-fetch:finished'));
        },
        LoadAppSettings() {
            eventBus.$emit('app-settings-fetch:started');
            this.FetchAppSettings()
                .then(() => {
                    this.appSettings = Object.assign({}, this.appSettingsReceived);
                    eventBus.$emit('app-settings-fetch:success');
                })
                .catch(error => eventBus.$emit('alert:error', error))
                .finally(() => eventBus.$emit('app-settings-fetch:finished'));
        },
        ReacquireAppToken(keycloakID, username, displayName) {
            if (sessionStorage.appToken != null) {
                let tokens = sessionStorage.appToken.split('.');

                if (tokens.length > 1) {
                    let segment2 = JSON.parse(atob(tokens[1]));
                    let expiryDate = new Date(segment2.exp * 1000);

                    if (expiryDate != null) {
                        let difference = expiryDate - new Date();

                        if (difference <= 0) {
                            clearInterval(this.appTokenIntervalID);
                            this.LoadAppAuthToken(keycloakID, username, displayName);
                        }
                    }
                }
            }
        }
    }
};